import React, { useMemo } from "react";
import { isNumber } from "lodash";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const IdleTimeCellContent: React.FC<IdleTimeCellContent.Props> = ({ item }) => {
	const { dateFns } = useAppContext();

	const idle = useMemo(
		() =>
			isNumber(item?.additionalFields?.idleTimeMilliseconds)
				? item.additionalFields.idleTimeMilliseconds
				: 0,
		[item?.additionalFields?.idleTimeMilliseconds],
	);

	const withClients = useMemo(
		() =>
			isNumber(item?.downtimes?.withClients)
				? item.downtimes.withClients
				: 0,
		[item?.downtimes?.withClients],
	);

	const content = useMemo(() => {
		const base = Math.max(idle, withClients);
		const total = Math.max(base, 0);
		if (!total) return "";

		return dateFns.formatTime(total, {
			formatTime: "HH:mm:ss",
			timezone: "UTC",
			isTimezone: true,
		});
	}, [idle, withClients, dateFns]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace IdleTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default IdleTimeCellContent;
